import { combineReducers } from 'redux'

// ACTIONS
export const FETCH = 'company/positionsDashboard/positions/FETCH'
export const FETCH_SUCCESS = 'company/positionsDashboard/positions/FETCH_SUCCESS'

export const FETCH_DETAIL = 'company/positionsDashboard/positions/FETCH_DETAIL'
export const FETCH_DETAIL_SUCCESS = 'company/positionsDashboard/positions/FETCH_DETAIL_SUCCESS'
export const FETCH_DETAIL_ERROR = 'company/positionsDashboard/positions/FETCH_DETAIL_ERROR'

export const UPDATE_DETAIL = 'company/positionsDashboard/positions/UPDATE_DETAIL'
export const UPDATE_DETAIL_SUCCESS = 'company/positionsDashboard/positions/UPDATE_DETAIL_SUCCESS'
export const UPDATE_DETAIL_ERROR = 'company/positionsDashboard/positions/UPDATE_DETAIL_ERROR'

export const ARCHIVE = 'company/positionsDashboard/positions/ARCHIVE'
export const ARCHIVE_SUCCESS = 'company/positionsDashboard/positions/ARCHIVE_SUCCESS'
export const ARCHIVE_ERROR = 'company/positionsDashboard/positions/ARCHIVE_ERROR'

export const UNARCHIVE = 'company/positionsDashboard/positions/UNARCHIVE'
export const UNARCHIVE_SUCCESS = 'company/positionsDashboard/positions/UNARCHIVE_SUCCESS'
export const UNARCHIVE_ERROR = 'company/positionsDashboard/positions/UNARCHIVE_ERROR'

export const SET_PUBLISHED_STATUS = 'company/positionsDashboard/positions/SET_PUBLISHED_STATUS'
export const SET_PUBLISH_SETTINGS = 'company/positionsDashboard/positions/SET_PUBLISH_SETTINGS'

export const RESET = 'company/positionsDashboard/positions/RESET'
export const RESET_DETAIL = 'company/positionsDashboard/positions/RESET_DETAIL'

export const TOGGLE_LOADING = 'company/positionsDashboard/positions/TOGGLE_LOADING'
export const TOGGLE_LOADING_DETAIL = 'company/positionsDashboard/positions/TOGGLE_LOADING_DETAIL'

// ACTION CREATORS
export const fetchDetail = (hiring_team_id, positionId) => ({
  type: FETCH_DETAIL,
  payload: {
    hiring_team_id,
    positionId,
  },
})

export const fetchDetailSuccess = ({ result }) => ({
  type: FETCH_DETAIL_SUCCESS,
  payload: {
    member: { ...result },
  },
})

export const fetchDetailError = errorMessage => ({
  type: FETCH_DETAIL_ERROR,
  payload: new Error(errorMessage),
})

export const updateDetail = (hiringTeamId, positionId, data, resolve, reject) => ({
  type: UPDATE_DETAIL,
  meta: { hiringTeamId, positionId, data, resolve, reject },
})

export const updateDetailSuccess = ({ result }) => ({
  type: UPDATE_DETAIL_SUCCESS,
  payload: {
    member: { ...result },
  },
})

export const updateDetailError = errorMessage => ({
  type: UPDATE_DETAIL_ERROR,
  payload: new Error(errorMessage),
})

export const archive = (hiringTeamId, positionId, data, resolve, reject) => ({
  type: ARCHIVE,
  meta: { hiringTeamId, positionId, data, resolve, reject },
})

export const archiveSuccess = ({ result }) => ({
  type: ARCHIVE_SUCCESS,
  payload: result,
})

export const archiveError = errorMessage => ({
  type: ARCHIVE_ERROR,
  payload: new Error(errorMessage),
})

export const unarchive = (hiringTeamId, positionId, data, resolve, reject) => ({
  type: UNARCHIVE,
  meta: { hiringTeamId, positionId, data, resolve, reject },
})

export const unarchiveSuccess = ({ result }) => ({
  type: UNARCHIVE_SUCCESS,
  payload: result,
})

export const unarchiveError = errorMessage => ({
  type: UNARCHIVE_ERROR,
  payload: new Error(errorMessage),
})

export const setPublishedStatus = publishedStatus => ({
  type: SET_PUBLISHED_STATUS,
  payload: { published_status: publishedStatus },
})

export const setPublishSettings = publishSettings => ({
  type: SET_PUBLISH_SETTINGS,
  payload: publishSettings,
})

export const reset = () => ({
  type: RESET,
})

export const resetDetail = () => ({
  type: RESET_DETAIL,
})

export const toggleLoading = loading => ({
  type: TOGGLE_LOADING,
  payload: { loading },
})

export const toggleLoadingDetail = loadingDetail => ({
  type: TOGGLE_LOADING_DETAIL,
  payload: { loadingDetail },
})

// REDUCERS
const collection = (state = [], { type, payload }) => {
  switch (type) {
    case FETCH_SUCCESS:
      return [...payload.collection]

    case RESET:
      return []

    default:
      return state
  }
}

const defaultMember = {
  interview_requests: [],
  placement_count: 0,
  subscribed_member_profiles: [],
  years_experience: [],
  cities: [],
  job_roles: [],
  keywords: [],
  must_have_skills: [],
  nice_to_have_skills: [],
}

const member = (state = defaultMember, { type, payload }) => {
  switch (type) {
    case FETCH_DETAIL_SUCCESS:
      return { ...payload.member }

    case UPDATE_DETAIL_SUCCESS:
      return { ...state, ...payload.member }

    case RESET_DETAIL:
      return defaultMember

    case UNARCHIVE_SUCCESS:
    case ARCHIVE_SUCCESS:
    case SET_PUBLISHED_STATUS: {
      return { ...state, ...payload }
    }
    case SET_PUBLISH_SETTINGS: {
      return { ...state, ...payload }
    }

    default:
      return state
  }
}

const defaultUtils = {
  loading: true,
  loadingDetail: true,
  fetchDetailError: null,
  creating: false,
  updating: false,
  archiving: false,
  unarchiving: false,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
    case TOGGLE_LOADING_DETAIL:
      return {
        ...state,
        ...payload,
      }

    case RESET:
    case RESET_DETAIL:
      return defaultUtils

    case UPDATE_DETAIL:
      return { ...state, updating: true }

    case UPDATE_DETAIL_ERROR:
    case UPDATE_DETAIL_SUCCESS:
      return { ...state, updating: false }

    case ARCHIVE:
      return { ...state, archiving: true }

    case ARCHIVE_ERROR:
    case ARCHIVE_SUCCESS:
      return { ...state, archiving: false }

    case UNARCHIVE:
      return { ...state, unarchiving: true }

    case UNARCHIVE_ERROR:
    case UNARCHIVE_SUCCESS:
      return { ...state, unarchiving: false }

    case FETCH_DETAIL_ERROR:
      return { ...state, fetchDetailError: payload }

    default:
      return state
  }
}

export default combineReducers({
  collection,
  member,
  utils,
})
